import { useTranslation } from "react-i18next";
import U2000BasicDialog from "./U2000BasicDialog";
import { IoCloseSharp } from "react-icons/io5";

import type { ReactNode } from "react";
import U2000ActionBtn from "../buttons/U2000ActionBtn";

interface U2000InfoDialogProps {
  isOpen: boolean;
  onClose: (action?: string) => void;
  title?: string;
  children?: ReactNode;
  width?: string;
}

function U2000InfoDialog({ isOpen, onClose, title, children, width }: U2000InfoDialogProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <U2000BasicDialog isOpen={isOpen} onClose={onClose} title={title} width={width}>
      <div>{children}</div>
      <div className="mt-6 flex justify-center gap-x-2 border-t-2 border-gray-300 p-4">
        <U2000ActionBtn label={t("dlgLblInfo")} icon={IoCloseSharp} handleClick={() => onClose("save")} />
      </div>
    </U2000BasicDialog>
  );
}

export default U2000InfoDialog;
